import { Tooltip as Ttip } from 'antd';
import React from 'react';

/**
 * A tooltip component
 *
 * {@link https://ant.design/components/tooltip#common-api}
 *
 * @module Tooltip
 * @param {Object} props - the tooltip props
 * @returns {React.ReactElement} a tooltip
**/
const Tooltip = ( { children, ...props } ) => {
    return (
        <Ttip arrow={ { pointAtCenter: true } } { ...props }>
            { children }
        </Ttip>
    );
};
export { Tooltip };
